import { useAppSelector } from "../../../../../hooks/useTypedSelector";
import React from "react";
import { RequestsCard } from "../commons/RequestsCard";
import { useTranslation } from "react-i18next";
import { CheckCircleFill } from "react-bootstrap-icons";
import { Spinner } from "react-bootstrap";

export const PackingList = () => {
  const { t } = useTranslation("common");

  const { loading, packingList } = useAppSelector((state) => state.packingList);

  if (loading) {
    return (
      <div className={"spinner-central"}>
        <Spinner size="sm" animation="grow" role="status" variant={"danger"} />
      </div>
    );
  }

  if (!packingList || !packingList.items.length) {
    return <div>{t("No packing list available for this day")}</div>;
  }

  return (
    <div>
      {packingList?.items.map((firstItem) => {
        const allFinalized = firstItem.items.every((item) =>
          item.requests.every((request) => request.finalized === true),
        );

        return (
          <div
            className={"d-flex flex-column mb-3 overflow-auto"}
            style={{ whiteSpace: "nowrap" }}
            key={firstItem.id}
          >
            <div className={"content-header"}>
              {allFinalized && (
                <div className={"me-2"}>
                  <CheckCircleFill style={{ color: "#23be55" }} />
                </div>
              )}

              <h3>{firstItem.source?.label ?? t("Unknown")}</h3>
            </div>

            <div className={"d-flex mt-3"}>
              {firstItem.items.map((secondItem) => (
                <RequestsCard secondItem={secondItem} key={secondItem.id} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
